import { render, staticRenderFns } from "./ParticipantSlider.vue?vue&type=template&id=66e097f4&scoped=true"
import script from "./ParticipantSlider.vue?vue&type=script&lang=js"
export * from "./ParticipantSlider.vue?vue&type=script&lang=js"
import style0 from "./ParticipantSlider.vue?vue&type=style&index=0&id=66e097f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e097f4",
  null
  
)

export default component.exports